import { defineComponent as D, computed as S, ref as c, watch as I, useSlots as H, openBlock as i, createBlock as h, unref as s, withCtx as g, renderSlot as w, createElementVNode as k, createTextVNode as K, toDisplayString as M, resolveDynamicComponent as Q, createVNode as $, createElementBlock as y, createCommentVNode as N } from "vue";
import W from "./ghl-ui.es238.js";
import X from "./ghl-ui.es192.js";
import Y from "./ghl-ui.es193.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es6.js";
import U from "./ghl-ui.es317.js";
import F from "./ghl-ui.es318.js";
import { getFlattenedOptions as O, showDebugging as p, getObjectByPath as V } from "./ghl-ui.es319.js";
import "./ghl-ui.es320.js";
import Z from "./ghl-ui.es191.js";
import ee from "./ghl-ui.es70.js";
import L from "./ghl-ui.es65.js";
import j from "./ghl-ui.es201.js";
import te from "./ghl-ui.es200.js";
const oe = { class: "dropdown-tree__container" }, ae = { class: "dropdown-tree__search" }, re = { key: 0 }, le = {
  key: 1,
  class: "no-data"
}, ne = { key: 1 }, se = {
  key: 1,
  class: "empty-search"
}, ie = D({
  name: "UIDropdownTree",
  inheritAttrs: !1,
  components: { UIInput: ee, UIButton: L, BreadCrumb: U, DropdownItem: F, NInput: j }
}), de = D({
  ...ie,
  props: {
    options: {
      type: Array,
      default: () => []
    },
    pathSeparator: {
      type: String,
      default: "/"
    },
    disabled: Boolean,
    triggerLabel: String,
    debug: Boolean,
    placement: String,
    loading: Boolean,
    remote: Boolean,
    searchPlaceholder: {
      type: String,
      required: !1,
      default: "Search"
    },
    trigger: {
      type: String,
      default: "click"
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["onSelect", "onSearch"],
  setup(r, { emit: x }) {
    const o = r, A = S(() => {
      const e = O(o.options).filter(
        (t) => t.type !== "parent"
      );
      return o.debug && p("flattenedOptions", e), e;
    }), E = S(() => {
      const e = O(o.options).filter(
        (t) => t.type === "parent"
      );
      return o.debug && p("flattenedParents", e), e;
    }), l = c(o.options);
    I(
      () => o.options,
      (e) => {
        l.value = e;
      }
    );
    const a = c(""), d = c(o.pathSeparator), f = c(null), m = H(), B = x, v = c(!1), R = (e) => {
      var t;
      (t = a.value) != null && t.includes(e) || (a.value ? a.value += `${e}${d.value}` : a.value += `${e}${d.value}`, l.value = V({ options: o.options, path: a.value }) ?? [], o.debug && p(
        `handleForwardTraversal(${e})`,
        `${JSON.stringify(l.value)}   ${a.value}`
      ));
    }, _ = (e) => {
      const t = e.split(d.value).filter(Boolean), n = t.slice(0, t.length - 1).join(d.value);
      a.value = n ? `${n}${d.value}` : "", l.value = V({ options: o.options, path: n }) ?? [], o.debug && p(`handleBackwardTraversal(${e})`, l.value);
    }, b = S(() => {
      const e = a.value.split(d.value).filter(Boolean).at(-1), t = E.value.find(
        (n) => n.value === e
      );
      return o.debug && p(`[Computed] currentViewTitle for ${e} is`, t), t;
    }), q = (e) => {
      if (a.value = "", v.value = !0, o.remote)
        B("onSearch", e);
      else if (e) {
        const t = A.value.filter(
          (n) => n.label.toLowerCase().includes(e.toLowerCase())
        );
        l.value = t;
      } else
        l.value = o.options, v.value = !1;
      o.debug && p(
        `handleSearch with remote ${o.remote} and search string is ${e}`,
        l.value
      );
    };
    I(
      () => f,
      Y((e) => {
        q(e.value);
      }, 300),
      { deep: !0 }
    );
    const z = () => {
      setTimeout(() => {
        l.value = o.options, f.value = null, a.value = "";
      }, 300);
    }, C = c(), J = (e) => {
      B("onSelect", e), G();
    }, G = () => {
      C.value.handleClick();
    };
    return (e, t) => (i(), h(s(te), {
      raw: "",
      class: "dropdown-tree",
      disabled: r.disabled,
      "show-arrow": !1,
      trigger: r.trigger,
      onClickoutside: z,
      placement: r.placement,
      ref_key: "popoverRef",
      ref: C,
      show: r.show
    }, {
      trigger: g(() => [
        s(m).trigger ? w(e.$slots, "trigger", {
          key: 0,
          disabled: r.disabled
        }, void 0, !0) : (i(), h(s(L), {
          key: 1,
          id: "dropdown-tree__trigger",
          class: "dropdown-tree__trigger",
          disabled: r.disabled,
          loading: r.loading
        }, {
          default: g(() => [
            k("span", null, [
              K(M(r.triggerLabel) + " ", 1),
              (i(), h(Q(s(W)), { class: "chevron" }))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      ]),
      default: g(() => {
        var n, P, T;
        return [
          k("div", oe, [
            k("div", ae, [
              $(s(j), {
                id: "dropdown-tree-search",
                placeholder: r.searchPlaceholder,
                value: f.value,
                "onUpdate:value": t[0] || (t[0] = (u) => f.value = u),
                loading: r.loading,
                size: "small"
              }, {
                prefix: g(() => [
                  s(m).searchIcon ? w(e.$slots, "searchIcon", { key: 0 }, void 0, !0) : (i(), h(s(X), {
                    key: 1,
                    class: "icon"
                  }))
                ]),
                _: 3
              }, 8, ["placeholder", "value", "loading"])
            ]),
            $(U, {
              show: !!a.value.length,
              title: (n = b.value) == null ? void 0 : n.label,
              disabled: !a.value,
              onOnClick: t[1] || (t[1] = (u) => _(a.value)),
              icon: (P = b.value) == null ? void 0 : P.icon,
              "icon-class": (T = b.value) == null ? void 0 : T.iconClass
            }, null, 8, ["show", "title", "disabled", "icon", "icon-class"]),
            $(F, {
              showPath: v.value,
              options: l.value,
              onOnForwardTraverse: t[2] || (t[2] = (u) => R(u.value)),
              onOnSelect: t[3] || (t[3] = (u) => J(u))
            }, null, 8, ["showPath", "options"]),
            !v.value && !r.options.length ? (i(), y("div", re, [
              s(m).empty ? w(e.$slots, "empty", { key: 0 }, void 0, !0) : (i(), y("p", le, "No data"))
            ])) : N("", !0),
            v.value && !l.value.length ? (i(), y("div", ne, [
              s(m).emptySearch ? w(e.$slots, "emptySearch", { key: 0 }, void 0, !0) : (i(), y("p", se, "No matching results found"))
            ])) : N("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["disabled", "trigger", "placement", "show"]));
  }
}), Ce = /* @__PURE__ */ Z(de, [["__scopeId", "data-v-41a35c8d"]]);
export {
  Ce as default
};
